import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from "@angular/core";
import {FUITabComponent} from "./tab/tab.component";

@Component({
    selector: "fui-tabs",
    styleUrls: ["./tabs.component.scss"],
    templateUrl: "./tabs.component.html"
})
export class FUITabsComponent implements AfterContentInit {
    private _active: FUITabComponent;
    @ContentChildren(FUITabComponent) tabs: QueryList<FUITabComponent>;
    @Output() public tabs$: EventEmitter<QueryList<FUITabComponent>>;
    @Output() public active$: EventEmitter<FUITabComponent>;

    constructor() {
        this.active$ = new EventEmitter<FUITabComponent>();
        this.tabs$ = new EventEmitter<QueryList<FUITabComponent>>();
    }

    ngAfterContentInit(): void {
        this.active = this.tabs.toArray()[0];
        this.tabs$.emit(this.tabs);
    }

    /**
     *
     * @param {FUITabComponent} tab
     * @returns {boolean}
     */
    isActive(tab: FUITabComponent): boolean {
        if (this.active === tab) {
            return true;
        }
        return false;
    }

    /**
     * Get the active tab
     * @returns {FUITabComponent}
     */
    get active(): FUITabComponent {
        return this._active;
    }

    /**
     * Set the active tab and emit it's value
     * @param {FUITabComponent} tab
     */
    @Input()
    set active(tab: FUITabComponent) {
        if (this._active !== tab) {
            this._active = tab;

            this.tabs.forEach((tab) => {
                if (tab === this.active) {
                    tab.setActive(true);
                }
                else {
                    tab.setActive(false);
                }
            });

            this.active$.emit(this.active);
        }
    }
}
